<div class="modal-header">
  <h4 class="modal-title">Upload Document</h4>
  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <ngx-file-drop (onFileDrop)="dropped($event)" (onFileOver)="fileOver($event)" (onFileLeave)="fileLeave($event)"
    [accept]="fileTypes" [multiple]="multiple" dropZoneClassName="Unused">
    <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
      <div [style]="{'border-color': dragIsIn ? 'red' : '#0782d0'}" class="FileSelectDropZone">
        <div style="height: 100px;"></div>
        <p [style]="{'color': dragIsIn ? 'red' : ''}">Drop {{fileTypesInstructionFragment}} to upload</p>
        <p [style]="{'color': dragIsIn ? 'red' : ''}">or</p>
        <button type="button" (click)="openFileSelector()">Browse for {{fileTypesInstructionFragment}} files</button>
      </div>
    </ng-template>
  </ngx-file-drop>
  <form>
    <div class="form-group">
      <label for="jotFormName">Jot Form Name</label>
      <input id="jotFormName" type="text" [(ngModel)]="jotFormName" class="form-control"
        placeholder="Form Name" name="formName">
    </div>
    <div class="form-group">
      <label for="jotFormLink">Jot Form Name</label>
      <input id="jotFormLink" type="text" [(ngModel)]="jotFormLink" class="form-control"
        placeholder="Form Link" name="formLink">
    </div>
    <button id="jot-form-button" type="button" class="btn btn-outline-dark" (click)="submitJotForm()">Submit</button>
  </form>
</div>
<div class="modal-footer">
  <span style="color: red;">{{errorMessage}}</span>
  <button type="button" class="btn btn-outline-dark" (click)="modal.close()">Close</button>
</div>
